var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.content.text)+"\n  "),_c('div',{staticClass:"col-sm-12 col-center-block"},_vm._l((_vm.content.quick_replies),function(reply,key){return _c('el-button',{key:key,attrs:{"size":"small"},on:{"click":function($event){_vm.sendCommand(reply.payload)}}},[_vm._v(_vm._s(reply.title))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-180d62f5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/sections/chat/QuickReplyMessage.vue
// module id = null
// module chunks = 